import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import GamePage from "./GamePage";

ReactDOM.render(
  <React.StrictMode>
    <GamePage />
  </React.StrictMode>,
  document.getElementById("root")
);
